/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum LegalTechSkill {
  BloombergLaw = "BloombergLaw",
  LexisNexisLexis = "LexisNexisLexis",
  PracticalLaw = "PracticalLaw",
  ThomsonReutersWestlaw = "ThomsonReutersWestlaw",
  vLex = "vLex",
  Avvoka = "Avvoka",
  ContractExpress = "ContractExpress",
  Draftwise = "Draftwise",
  Hotdocs = "Hotdocs",
  LiteraDraftingTools = "LiteraDraftingTools",
  ThomsonReutersDraftingAssistant = "ThomsonReutersDraftingAssistant",
  AdobeReader = "AdobeReader",
  DocuSign = "DocuSign",
  DraftPilot = "DraftPilot",
  EBrevia = "EBrevia",
  Evisort = "Evisort",
  HarveyAI = "HarveyAI",
  Kira = "Kira",
  Leya = "Leya",
  Luminance = "Luminance",
  Screens = "Screens",
  Spellbook = "Spellbook",
  ThomsonReutersCoCounsel = "ThomsonReutersCoCounsel",
  Thoughtriver = "Thoughtriver",
  IntelAgree = "IntelAgree",
  Agiloft = "Agiloft",
  Cobblestone = "Cobblestone",
  Conga = "Conga",
  ContractPodAI = "ContractPodAI",
  Contractworks = "Contractworks",
  Coupa = "Coupa",
  Icertis = "Icertis",
  Ironclad = "Ironclad",
  Linksquares = "Linksquares",
  SAPAriba = "SAPAriba",
  Sirion = "Sirion",
  SpotDraft = "SpotDraft",
  SpringCM = "SpringCM",
  Box = "Box",
  Dropbox = "Dropbox",
  GoogleDrive = "GoogleDrive",
  iManage = "iManage",
  Navex = "Navex",
  NetDocuments = "NetDocuments",
  Sharepoint = "Sharepoint",
  HighQ = "HighQ",
  Legatics = "Legatics",
  TeamConnect = "TeamConnect",
  Casepoint = "Casepoint",
  Disco = "Disco",
  Everlaw = "Everlaw",
  Exterro = "Exterro",
  KLDiscovery = "KLDiscovery",
  Relativity = "Relativity",
  Reveal = "Reveal",
  Confluence = "Confluence",
  Excel = "Excel",
  GemsEntityManagement = "GemsEntityManagement",
  HCueEntityManagement = "HCueEntityManagement",
  Jira = "Jira",
  MicrosoftCoPilot = "MicrosoftCoPilot",
  MicrosoftTeams = "MicrosoftTeams",
  OneTrustPrivacy = "OneTrustPrivacy",
  Salesforce = "Salesforce",
  ServiceNow = "ServiceNow",
  Slack = "Slack",
  GoogleWorkspace = "GoogleWorkspace",
  Asana = "Asana",
  Zoom = "Zoom",
  Workiva = "Workiva",
  Tableau = "Tableau",
  Veeva = "Veeva",
}

export const LegalTechSkillDisplay: Record<LegalTechSkill, string> = {
  [LegalTechSkill.BloombergLaw]: "Bloomberg Law",
  [LegalTechSkill.LexisNexisLexis]: "LexisNexis Lexis+",
  [LegalTechSkill.PracticalLaw]: "Practical Law",
  [LegalTechSkill.ThomsonReutersWestlaw]: "Thomson Reuters Westlaw",
  [LegalTechSkill.vLex]: "vLex",
  [LegalTechSkill.Avvoka]: "Avvoka",
  [LegalTechSkill.ContractExpress]: "Contract Express",
  [LegalTechSkill.Draftwise]: "Draftwise",
  [LegalTechSkill.Hotdocs]: "Hotdocs",
  [LegalTechSkill.LiteraDraftingTools]: "Litera Drafting tools",
  [LegalTechSkill.ThomsonReutersDraftingAssistant]: "Thomson Reuters Drafting Assistant",
  [LegalTechSkill.AdobeReader]: "Adobe Reader",
  [LegalTechSkill.DocuSign]: "DocuSign",
  [LegalTechSkill.DraftPilot]: "DraftPilot",
  [LegalTechSkill.EBrevia]: "eBrevia",
  [LegalTechSkill.Evisort]: "Evisort",
  [LegalTechSkill.HarveyAI]: "Harvey AI",
  [LegalTechSkill.Kira]: "Kira",
  [LegalTechSkill.Leya]: "Legora (formerly Leya)",
  [LegalTechSkill.Luminance]: "Luminance",
  [LegalTechSkill.Screens]: "Screens",
  [LegalTechSkill.Spellbook]: "Spellbook",
  [LegalTechSkill.ThomsonReutersCoCounsel]: "Thomson Reuters CoCounsel",
  [LegalTechSkill.Thoughtriver]: "Thoughtriver",
  [LegalTechSkill.IntelAgree]: "IntelAgree",
  [LegalTechSkill.Agiloft]: "Agiloft",
  [LegalTechSkill.Cobblestone]: "Cobblestone",
  [LegalTechSkill.Conga]: "Conga",
  [LegalTechSkill.ContractPodAI]: "ContractPodAI",
  [LegalTechSkill.Contractworks]: "Contractworks",
  [LegalTechSkill.Coupa]: "Coupa",
  [LegalTechSkill.Icertis]: "Icertis",
  [LegalTechSkill.Ironclad]: "Ironclad",
  [LegalTechSkill.Linksquares]: "Linksquares",
  [LegalTechSkill.SAPAriba]: "SAP Ariba",
  [LegalTechSkill.Sirion]: "Sirion",
  [LegalTechSkill.SpotDraft]: "SpotDraft",
  [LegalTechSkill.SpringCM]: "SpringCM",
  [LegalTechSkill.Box]: "Box",
  [LegalTechSkill.Dropbox]: "Dropbox",
  [LegalTechSkill.GoogleDrive]: "Google Drive",
  [LegalTechSkill.iManage]: "iManage",
  [LegalTechSkill.Navex]: "Navex",
  [LegalTechSkill.NetDocuments]: "NetDocuments",
  [LegalTechSkill.Sharepoint]: "Sharepoint",
  [LegalTechSkill.HighQ]: "HighQ",
  [LegalTechSkill.Legatics]: "Legatics",
  [LegalTechSkill.TeamConnect]: "TeamConnect",
  [LegalTechSkill.Casepoint]: "Casepoint",
  [LegalTechSkill.Disco]: "Disco",
  [LegalTechSkill.Everlaw]: "Everlaw",
  [LegalTechSkill.Exterro]: "Exterro",
  [LegalTechSkill.KLDiscovery]: "KLDiscovery",
  [LegalTechSkill.Relativity]: "Relativity",
  [LegalTechSkill.Reveal]: "Reveal",
  [LegalTechSkill.Confluence]: "Confluence",
  [LegalTechSkill.Excel]: "Excel",
  [LegalTechSkill.GemsEntityManagement]: "Gems Entity Management",
  [LegalTechSkill.HCueEntityManagement]: "HCue Entity Management",
  [LegalTechSkill.Jira]: "Jira",
  [LegalTechSkill.MicrosoftCoPilot]: "Microsoft CoPilot",
  [LegalTechSkill.MicrosoftTeams]: "Microsoft Teams",
  [LegalTechSkill.OneTrustPrivacy]: "OneTrust Privacy",
  [LegalTechSkill.Salesforce]: "Salesforce",
  [LegalTechSkill.ServiceNow]: "ServiceNow",
  [LegalTechSkill.Slack]: "Slack",
  [LegalTechSkill.GoogleWorkspace]: "Google Workspace",
  [LegalTechSkill.Asana]: "Asana",
  [LegalTechSkill.Zoom]: "Zoom",
  [LegalTechSkill.Workiva]: "Workiva",
  [LegalTechSkill.Tableau]: "Tableau",
  [LegalTechSkill.Veeva]: "Veeva",
};
